import type { ReactNode } from "react";

interface ActionButtonProps {
  onClick: () => void;
  icon: ReactNode;
  label: string;
  variant?: "primary" | "secondary";
}

const VARIANT_CLASSES = {
  primary: "bg-btn-action text-text-btn",
  secondary: "bg-bg-secondary text-text-primary",
} as const;

export function ActionButton({ onClick, icon, label, variant = "primary" }: ActionButtonProps) {
  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center gap-2 h-[40px] px-4 rounded-xl text-sm ${VARIANT_CLASSES[variant]}`}
    >
      {icon}
      {label}
    </button>
  );
}
